import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useLogout, useWhoAmI } from '@/api/queries'

/**
 * The authenticated principal's role/team, driving what /admin/v2/services
 * and /admin/v2/dashboards return (FR-ORG-04). "Switch persona" is a real
 * re-authentication, not a backdoor: it logs out and lets the login view's
 * next WebAuthn ceremony establish a different principal, at which point
 * every scoped query refetches under the new grants.
 */
export function PersonaIndicator() {
  const { data, isLoading, isError } = useWhoAmI()
  const doLogout = useLogout()

  if (isLoading || isError || !data) return null

  const { principal } = data
  const roleLabel = principal.roles[0]?.toUpperCase() ?? (principal.kind === 'dev-token' ? 'DEV-TOKEN' : 'UNKNOWN')
  const scopeLabel = principal.seesAllServices ? 'sees the whole fleet' : 'scoped visibility'
  const title = `Role: ${roleLabel} · teams: ${principal.teams.join(', ') || '—'} · ${scopeLabel} (FR-ORG-04)`

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 rounded-[7px] bg-accent-weak px-2.5 py-1.5 text-[12px] font-bold text-accent"
          title={title}
        >
          {roleLabel}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onSelect={() => void doLogout()}>Log out / switch persona</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
